import { type ReactNode } from 'react';

import { IconButton } from '@breezeventures/ui-kit/icon-button';
import { Icon } from '@breezeventures/ui-kit/next/icon';
import cn from 'classnames';

import logo from '../../../assets/logo/logo-horizontal-brand.svg';

export type ScreenHeaderProps = {
  onBack?: () => void;
  onClose?: () => void;
  logoAlign?: 'left' | 'center';
  rightSlot?: ReactNode;
};

export const ScreenHeader = ({
  onBack,
  onClose,
  rightSlot,
  logoAlign = 'center',
}: ScreenHeaderProps) => {
  return (
    <div
      className={cn('grid min-h-16 items-center gap-4 bg-white', {
        'p-4': !!rightSlot,
        'grid-cols-[1fr_auto_1fr]': logoAlign === 'center',
        'grid-cols-[0px_auto_1fr]': logoAlign === 'left',
      })}
    >
      <div className="flex">
        {onBack && (
          <IconButton
            variant="ghost"
            size="l"
            type="button"
            onClick={onBack}
            aria-label="Go back"
          >
            <Icon
              name="arrow-back"
              size={24}
              version="v1"
              className="size-8.5"
              color="var(--color-primitive-primary)"
            />
          </IconButton>
        )}
      </div>

      <img src={logo} alt="Skyro" className="h-8.5" />

      <div className="flex justify-end">
        {onClose && (
          <IconButton
            variant="ghost"
            size="l"
            type="button"
            onClick={onClose}
            aria-label="Close"
          >
            <Icon
              name="cross-s"
              size={24}
              version="v1"
              className="size-8.5"
              color="var(--color-primitive-primary)"
            />
          </IconButton>
        )}
        {rightSlot}
      </div>
    </div>
  );
};
